import stages from '../../constants/stages';
import { SubmitTraitsGenerationContract } from '../stage-contracts';
import getStateDifferencePerBreakpoint from '../get-state-difference-per-breakpoint';
import filterStateByTargets from '../filter-state-by-targets';

const handleMergeResult = (currentFlowData, result) => {
  if (!result) return currentFlowData;

  if (!SubmitTraitsGenerationContract.isValid(result)) {
    // eslint-disable-next-line no-console
    console.warn(
      `${String(
        stages.SUBMIT_TRAITS_GENERATION
      )} stage: handler returned invalid contract, skipping`
    );
    return currentFlowData;
  }

  const traits = SubmitTraitsGenerationContract.get(result);

  if (!traits) return currentFlowData;

  const merged = { ...currentFlowData };
  const currentTraits = merged.traits || {};

  merged.traits = Object.keys(traits).reduce(
    (acc, deviceMode) => ({
      ...acc,
      [deviceMode]: {
        ...(acc[deviceMode] || {}),
        ...traits[deviceMode],
      },
    }),
    currentTraits
  );

  return merged;
};

const runSubmitTraitsGenerationStage = ({ state, form, flowData, onRun }) => {
  const initialState = state.getInitialState();
  const stateDifferencePerBreakpoint = getStateDifferencePerBreakpoint(initialState, state.data);

  return onRun({
    stage: stages.SUBMIT_TRAITS_GENERATION,
    initialContext: {
      getDefaultFieldsValues: form.getDefaultValues,
      getFieldsValues: form.getValues,
      state: state.data,
    },
    flowData,
    onMergeResult: handleMergeResult,
    getAdditionalContext: ({ chunkId }) => ({
      chunkStateDifference: filterStateByTargets(
        stateDifferencePerBreakpoint,
        state.getModifiedTargets(chunkId)
      ),
    }),
  });
};

export default runSubmitTraitsGenerationStage;
